export class Endereco {
  public EnderecoId = '';
  public ContaId = '';
  public Logradouro = '';
  public Numero = '';
  public Complemento = '';
  public Bairro = '';
  public Cidade = '';
  public Estado = '';
  public Cep = '';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/endereco.ts